import * as React from "react";
import { useLocalStorage } from "@grandvisionhq/utils";
const DEFAULT_LIMIT = 20;
function useViewHistory(key, limit = DEFAULT_LIMIT) {
  const [history, setHistory] = useLocalStorage(key, void 0);
  const has = React.useCallback(
    (id) => Boolean(history && history.find((i) => i === id)?.length),
    [history]
  );
  const add = React.useCallback(
    (id) => {
      setHistory((state = []) => {
        const hasId = Boolean(state.find((i) => i === id)?.length);
        const filtered = hasId ? [...state.filter((i) => i !== id)] : [...state];
        return [id, ...filtered].slice(0, limit);
      });
    },
    [limit]
  );
  const remove = React.useCallback((ids) => {
    setHistory((state = []) => {
      const filters = Array.isArray(ids) ? ids : [ids];
      return filters.reduce((result, next) => [...result.filter((i) => i !== next)], [...state]);
    });
  }, []);
  const clear = React.useCallback(() => {
    setHistory([]);
  }, []);
  return { history, has, add, remove, clear };
}
export {
  DEFAULT_LIMIT,
  useViewHistory
};
//# sourceMappingURL=use-view-history.js.map
